import React from 'react';
import {Control, useController, useFormContext} from 'react-hook-form';
import {StyleSheet, View} from 'react-native';
import Checkbox from './Checkbox';

export interface BTCheckboxProps {
  name: string;
  label?: string;
  control?: Control<any>;
  rules?: object;
  defaultValue?: any;
  disabled?: boolean;
  valueType?: 'boolean' | 'string' | 'number';
  onValChange?: (value: any) => void;
}

const BTCheckbox = (props: BTCheckboxProps) => {
  const {
    label = '',
    name,
    control: propControl,
    rules,
    defaultValue,
    disabled = false,
    valueType,
    onValChange,
  } = props;

  const context = useFormContext();
  const effectiveControl = propControl || context?.control;

  const {
    field: {onChange, value},
  } = useController({
    name,
    control: effectiveControl,
    rules,
    defaultValue,
  });

  const handleValueChange = (newChecked: boolean) => {
    let newValue: any = newChecked;

    if (valueType === 'string') {
      newValue = newChecked ? '1' : '0';
    } else if (valueType === 'number') {
      newValue = newChecked ? 1 : 0;
    } else if (valueType === 'boolean') {
      newValue = newChecked;
    } else if (typeof value === 'string') {
      newValue = newChecked ? '1' : '0';
    } else if (typeof value === 'number') {
      newValue = newChecked ? 1 : 0;
    } else if (typeof value === 'boolean') {
      newValue = newChecked;
    } else if (typeof defaultValue === 'string') {
      newValue = newChecked ? '1' : '0';
    } else if (typeof defaultValue === 'number') {
      newValue = newChecked ? 1 : 0;
    } else if (typeof defaultValue === 'boolean') {
      newValue = newChecked;
    } else {
      newValue = newChecked ? '1' : '0';
    }

    onChange(newValue);
    if (onValChange) {
      onValChange(newValue);
    }
  };

  return (
    <View style={styles.container}>
      <Checkbox
        label={label}
        value={value}
        disabled={disabled}
        onValueChange={handleValueChange}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    minHeight: 50,
  },
});

export default BTCheckbox;
